import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid, TextField, Typography
} from '@mui/material';
import {licensingService} from "../../../../../store/services";
import { JSEncrypt } from 'jsencrypt';
import { alertActions, userActions } from '../../../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { history } from '../../../../../helpers/history';
import customSelectStyle from '../../../../../assets/jss/customSelectStyle';

const useStyles = makeStyles(theme => ({
  root: {
    actions: {
      justifyContent: 'flex-end'
    },
    margin: 0,
    padding: 0,
  },
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleHeader: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.white,
  },
  title: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.white,
    fontSize: "large"
  },
  subheader: {
    color: theme.palette.white
  },
  button: {
    margin: theme.spacing(2),
    marginTop: 0,
    color: theme.palette.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light
    }
  },
  icon: {
    height: 32,
    width: 32,
    color: theme.palette.primary.main
  },
  action: {
    margin: 0
  },
  ...customSelectStyle
}));

const NewLicense = props => {
  const { randomPhrase,
    request_filename,
    ...rest } = props;

  const classes = useStyles();

  const dispatch = useDispatch();
  const user = useSelector(state => state.authentication.user);

  const getPublicKey = () => {
    return licensingService.readPublicKey()
      .then(
        response => {
          return (response.data.publicKey)
        }
      )
      .catch(
        error => {
          return error;
        }
      );
  }

  async function onSaveFile () {
    const publicKey = getPublicKey();

    // Initialize JSEncrypt instance with the public key
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(await publicKey);

    // Encrypt data
    const encrypted = encryptor.encrypt(randomPhrase);

    const blob = new Blob([encrypted], { type: 'application/text' });
    const a = document.createElement('a');

    a.download = request_filename + ".enc"; // Set the desired filename
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', (e) => {
      setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000); // Clean up after download
    });
    a.click();

    dispatch(alertActions.error("Send the downloaded encrypted file to request new license."));
    dispatch(userActions.logout(user));
  }

  const onUploadLicenseFiles = () => {
    history.push({
      pathname: '/license/upload'
    });
  }

  return (
    <Card
      {...rest}
      className={classes.root}
    >
      <form>
        <CardHeader
          className={classes.titleHeader}
          classes={{
            action: classes.action,
            subheader: classes.subheader,
            title: classes.title
          }}
          subheader="New License Request"
          title="MISSING LICENSE"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={6}
            wrap="wrap"
          >
            <Grid
              className={classes.item}
              item
              sm={6}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={true}
                label="Random Phrase"
                margin="dense"
                id="random_phrase"
                name="random_phrase"
                type="text"
                value={randomPhrase}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Divider />
          <CardActions>
            <Button
              color="primary"
              className={classes.button}
              variant="outlined"
              onClick={onSaveFile}
            >
              Save
            </Button>
            <Typography style={{ padding: 5 }}>
              Do you have a public key, license file or signature file to upload?
            </Typography>
            <Button
              className={classes.button}
              variant="outlined"
              onClick={onUploadLicenseFiles}
            >
              Upload License Files
            </Button>
          </CardActions>

        </CardContent>
      </form>

    </Card>
  );
};

NewLicense.propTypes = {
  className: PropTypes.string
};

export default NewLicense;
